<div class="card card-custom gutter-b card-strech">
    <div class="card-header card-header-tabs-line">
        <div class="card-toolbar">
            <ul class="nav nav-tabs nav-bold nav-tabs-line">
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': info }" data-toggle="tab" href="#pills-info"
                        (click)="ver('info')">
                        <span class="nav-text">Client Info</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': family }" id="pills-family-tab" data-toggle="tab"
                        data-bs-target="#pills-family" href="#pills-family" (click)="ver('family')">
                        Family
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': contacts }" id="pills-contacts-tab" data-toggle="tab"
                        data-bs-target="#pills-contacts" href="#pills-contacts" (click)="ver('contacts')">
                        Contacts
                    </a>
                </li>
                <!-- <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': emails }" id="pills-emails-tab" data-toggle="tab"
                        data-bs-target="#pills-emails" href="#pills-emails" (click)="ver('emails')">
                        Emails
                    </a>
                </li> -->
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': appts }" id="pills-appts-tab" data-toggle="tab"
                        data-bs-target="#pills-appts" href="#pills-appts" (click)="ver('appts')">
                        Appointments
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': finantial }" id="pills-finantial-tab" data-toggle="tab"
                        data-bs-target="#pills-finantial" href="#pills-finantial" (click)="ver('finantial')">
                        Financial
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': notes }" id="pills-notes-tab" data-toggle="tab"
                        data-bs-target="#pills-notes" href="#pills-notes" (click)="ver('notes')">
                        Notes
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': recall }" id="pills-recall-tab" data-toggle="tab"
                        data-bs-target="#pills-recall" href="#pills-recall" (click)="ver('recall')">
                        Recall
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': documents }" id="pills-documents-tab" data-toggle="tab"
                        data-bs-target="#pills-documents" href="#pills-documents" (click)="ver('documents')">
                        Documents
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <div class="tab-content">
        <div class="tab-pane fade" [ngClass]="{ 'show active': info }" id="pills-info" role="tabpanel"
            aria-labelledby="pills-info-tab">
            <ngx-work-client-info [client_no]="client_no"></ngx-work-client-info>
        </div>
        <div class="tab-pane fade" [ngClass]="{ 'show active': family }" id="pills-family" role="tabpanel"
            aria-labelledby="pills-family-tab">
            <ngx-work-family [client_no]="client_no"></ngx-work-family>
        </div>
        <div class="tab-pane fade" [ngClass]="{ 'show active': contacts }" id="pills-contacts" role="tabpanel"
            aria-labelledby="pills-contacts-tab">
            <ngx-work-contacts [client_no]="client_no"></ngx-work-contacts>
        </div>
        <!-- <div class="tab-pane fade" [ngClass]="{ 'show active': emails }" id="pills-emails" role="tabpanel"
            aria-labelledby="pills-emails-tab">
            <ngx-client-email [client_no]="client_no"></ngx-client-email>
        </div> -->
        <div class="tab-pane fade" [ngClass]="{ 'show active': appts }" id="pills-appts" role="tabpanel"
            aria-labelledby="pills-appts-tab">
            <ngx-work-appointments [client_no]="client_no" [pet_no]="0" [type]="'client'"></ngx-work-appointments>
        </div>
        <div class="tab-pane fade" [ngClass]="{ 'show active': finantial }" id="pills-finantial" role="tabpanel"
            aria-labelledby="pills-finantial-tab">
            <ngx-work-financial [client_no]="client_no"></ngx-work-financial>
        </div>
        <div class="tab-pane fade" [ngClass]="{ 'show active': notes }" id="pills-notes" role="tabpanel"
            aria-labelledby="pills-notes-tab">
            <ngx-client-note></ngx-client-note>
        </div>
        <div class="tab-pane fade" [ngClass]="{ 'show active': recall }" id="pills-recall" role="tabpanel"
            aria-labelledby="pills-recall-tab">
            <ngx-work-recall [pet_no]="pet_no"></ngx-work-recall>
        </div>
        <div class="tab-pane fade" [ngClass]="{ 'show active': documents }" id="pills-documents" role="tabpanel"
            aria-labelledby="pills-documents-tab">
            <ngx-document [client_no]="client_no" [pet_no]="0"></ngx-document>
        </div>
    </div>
</div>